window.ConfirmName = (function ($) {
    let self = {
        elements: {
            confirmForm: '.confirm-name',
            checkboxClass: '.vds-checkbox__input',
            validationMessage: '.vds-form__validation-message--invalid',
            titleInput: '.vds-link-list__item.title .vds-link-list__data.title',
            lastNameInput: '.vds-link-list__item.last-name .vds-link-list__data.lastName',
        },
        css: {
            invalidCheckboxError: 'vds-checkbox--invalid',
            itemHidden: 'vds-item-hidden'
        },
        urls: {
            savePersonalDetails: '/api/sitecore/MyAccount/SavePersonalDetails',
            details: '/my-account/details',
            errorPageUrl: '/error/error-page'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
                self.func.initializeValidationMessage();
            },
            bindings: function () {
                $(self.elements.confirmForm).on('submit', self.func.handleContinue);
                $(self.elements.checkboxClass).on('change', self.func.clearValidationMessage);
            },
            initializeValidationMessage: function () {
                $(self.elements.validationMessage).hide();
            },
            clearValidationMessage: function () {
                // Hide all validation messages
                $(self.elements.validationMessage).hide();
                // Remove invalid class from all checkboxes
                $(self.elements.checkboxClass).removeClass(self.css.invalidCheckboxError);
            },
            handleContinue: function (event) {
                event.preventDefault();
                self.func.clearValidationMessage();

                if (!self.func.validateCheckboxes()) {
                    return;
                }

                const formData = self.func.gatherFormData();
                self.func.sendFormData(formData);
            },
            validateCheckboxes: function () {
                let allCheckboxesValid = true;

                $(self.elements.checkboxClass).each(function () {
                    const $checkbox = $(this);
                    const $validationMessage = $checkbox.closest('.vds-form__group').find(self.elements.validationMessage);

                    if (!$checkbox.is(':checked')) {
                        $checkbox.addClass(self.css.invalidCheckboxError);
                        $validationMessage.show();
                        allCheckboxesValid = false;
                    } else {
                        $checkbox.removeClass(self.css.invalidCheckboxError);
                        $validationMessage.hide();
                    }
                });

                return allCheckboxesValid;
            },
            gatherFormData: function () {
                const title = $(self.elements.titleInput).text().trim();
                const surname = $(self.elements.lastNameInput).text().trim();

                return {
                    title: title,
                    surname:surname
                };
            },
            sendFormData: function (formData) {
                $.ajax({
                    url: self.urls.savePersonalDetails,
                    method: 'PATCH',
                    contentType: 'application/json',
                    data: JSON.stringify(formData),
                    success: function (response) {
                        if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                            sessionStorage.setItem('snackbarMessage', 'Name Changed');
                            sessionStorage.setItem('snackbarSuccess', 'true');
                            window.location.href = self.urls.details;
                        } else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    },
                });
            },
        }
    };

    return {
        Init: self.func.init
    };
})(jQuery);

$(document).ready(function () {
    if ('confirmName' === $('.confirm-name').data('feature')) {
        window.ConfirmName.Init();
    }
});
